import {useEffect, useState} from "react";
import {RangeInput, RangeValue} from "@/shared/ui/RangeInput";
import {validateRangeFilter} from "../lib/validateRangeFilter";
import {RangeFilterOption} from "../model/types";

type Props = {
    option: RangeFilterOption;
    loading?: boolean;
    onChange: (
        values: {
            value_min: number;
            value_max: number;
        }
    ) => void;
};

export const CatalogRangeFilter = (
    {
        option,
        loading = false,
        onChange,
    }: Props
) => {
    const [range, setRange] = useState<RangeValue>({
        min: option.selected_min || option.value_min,
        max: option.selected_max || option.value_max,
    });

    // useEffect(() => {
    //     if (!range.min && !range.max) {
    //         setRange({
    //             min: option.selected_min ?? option.value_min,
    //             max: option.selected_max ?? option.value_max,
    //         });
    //     }
    // }, []);

    useEffect(() => {
        setRange({
            min: option.selected_min || option.value_min,
            max: option.selected_max || option.value_max,
        });
    }, [
        option.selected_min,
        option.selected_max,
        option.value_min,
        option.value_max,
    ]);

    const handleChange = (
        nextRange: RangeValue,
    ) => {
        setRange(nextRange);
    };

    const handleBlur = (field: "min" | "max") => {
        const validatedRange = validateRangeFilter({
            valueMin: range.min,
            valueMax: range.max,

            controlMin: option.value_min,
            controlMax: option.value_max,

            changedField:
                field === "min"
                    ? "value_min"
                    : "value_max",
        });

        setRange({
            min: validatedRange.value_min,
            max: validatedRange.value_max,
        });

        onChange(validatedRange);
    };

    return (
        <RangeInput
            value={range}
            loading={loading}
            onChange={handleChange}
            onBlur={handleBlur}
        />
    );
};
